import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Typography } from './Typography';
import { colors } from '../constants';
const Button = _ref => {
  let {
    label,
    startIcon,
    endIcon,
    buttonContainerStyle,
    buttonTextStyle,
    disabled,
    disabledButtonContainerStyle,
    disabledButtonTextStyle,
    handlePress
  } = _ref;
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: handlePress,
    style: [styles.container, buttonContainerStyle, disabled ? disabledButtonContainerStyle : {}],
    disabled: disabled
  }, startIcon, /*#__PURE__*/React.createElement(Typography.ActionSmall, {
    textStyle: [styles.text, buttonTextStyle, disabled ? disabledButtonTextStyle : {}]
  }, label), endIcon);
};
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.amethyst400,
    borderRadius: 5,
    margin: 5
  },
  text: {
    color: colors.neutral0,
    padding: 5
  }
});
export default Button;
//# sourceMappingURL=Button.js.map